import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",

    // BRAND (used sparingly)
    primary: {
      main: "#2563EB",
      light: "#DBEAFE",
      dark: "#1D4ED8",
      contrastText: "#FFFFFF",
    },

    // BACKGROUNDS
    background: {
      default: "#F8FAFC", // app bg
      paper: "#FFFFFF",   // cards
    },

    // TEXT
    text: {
      primary: "#0F172A",
      secondary: "#475569",
      disabled: "#94A3B8",
    },

    // BORDERS / DIVIDERS
    divider: "#E2E8F0",

    // STATUS COLORS (critical for your product)
    success: {
      main: "#16A34A",
      light: "#EAF3DE",
      dark: "#27500A",
    },

    warning: {
      main: "#F59E0B",
      light: "#FAEEDA",
      dark: "#633806",
    },

    error: {
      main: "#DC2626",
      light: "#FCEBEB",
      dark: "#791F1F",
    },

    info: {
      main: "#0EA5E9",
      light: "#E6F1FB",
      dark: "#0C447C",
    },

    // CUSTOM EXTENSIONS (important for your use case)
    custom: {
      sidebar: {
        bg: "#0B0B09",
        text: "#F7F4EE",
        muted: "rgba(247,244,238,0.5)",
        border: "rgba(255,250,240,0.08)",
      },
      accent: {
        greenDark: "#1B3A2D", // buttons, avatar
        greenHover: "#2A5040",
      },
    },
  },

  shape: {
    borderRadius: 10,
  },

  typography: {
    fontFamily: "Inter, system-ui, sans-serif",
    fontSize: 13,

    h6: {
      fontSize: "14px",
      fontWeight: 500,
    },

    body2: {
      fontSize: "12.5px",
    },
  },

  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          border: "0.5px solid #E2E8F0",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 8,
        },
        containedPrimary: {
          backgroundColor: "#1B3A2D",
          color: "#E8F0EB",
          "&:hover": {
            backgroundColor: "#2A5040",
          },
        },
      },
    },

    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "0.5px solid #E2E8F0",
          fontSize: "12.5px",
        },
        head: {
          fontSize: "10.5px",
          textTransform: "uppercase",
          letterSpacing: "0.05em",
          color: "#94A3B8",
          backgroundColor: "#F1F5F9",
        },
      },
    },
  },
});

export default theme;